export default __webpack_public_path__ + "static/media/whiteblood.399657c0.jpg";